<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="app">
    <div class="app-loading"></div>
    <router-view></router-view>
    <div class="loading-for-commands">
      <Loader :visible="loading"/>
    </div>
  </div>
</template>
<style>
#app {
  position: relative;
}
.loading-for-commands {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script>
import Loader from "@/components/loader";
import { mapState } from "vuex";
import { HubConnectionBuilder } from "@microsoft/signalr";
export default {
    components: {
    Loader
  },
  watch: {
    "$store.state.theme"(val) {
      this.toggleClassInBody(val);
    }
  },
    computed: {
    ...mapState("loader", ["loading"])
  },
  async created() {
    const hubConnectionBuilder = new HubConnectionBuilder().withUrl("https://apigateway.avajang.com/apigateway/broadcastHub").build();
    await hubConnectionBuilder.start();
    hubConnectionBuilder.on("ReceiveMessage",event => {
    localStorage.setItem('notification', event)
    window.dispatchEvent(new CustomEvent('notification-event', {
    detail: {
    message: localStorage.getItem('notification')}
    }));
   });

    try {
      await this.$auth.renewTokens();
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    handleWindowResize(event) {
      this.$store.dispatch("updateWindowWidth", event.currentTarget.innerWidth);
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.handleWindowResize);
    });
    this.$store.dispatch("updateWindowWidth", window.innerWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
  }
};
</script>
